<template>
  <FormTabsBlockComponent
    :loading="loading"
    :tabs="tabs"
    :invalidTab="invalidTab"
    :keepHideValue="true"
    @uploading="uploading"
    @uploaded="uploaded"
    @formCancel="cancel"
    @formSubmit="submit"
  />
</template>

<script>
import { notificationManager } from "@/services/utilities/notification-manager";
import FormTabsBlockComponent from "@/components/blocks/FormTabsBlockComponent.vue";
import { formManager } from "@/services/form/form-manager";
import { apiConnection } from "@/services/api-connection";
import { formValidator } from "@/services/form/form-validator";
import { mapActions } from "pinia";
import { usePlatformStore } from "@/store/platform/platform";
import { trainingManager } from "@/services/training/training-manager";
import { useMainStore } from "@/store/main/main";

export default {
  data() {
    return {
      loading: false,
      tabs: [],
      invalidTab: null,
      fileUpload: false,
      id: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      this.id = this.$route.params.id;
      trainingManager.form("apprentice", this.id).then((data) => {
        this.tabs = data.tabs;
        this.loading = false;
        this.setAppLoading(false);
      });
    },

    cancel() {
      this.$router.push({
        name: "RegistrationApprenticeList",
      });
    },

    submit() {
      let response = [];
      this.loading = true;
      this.invalidTab = null;

      Object.values(this.tabs).forEach((tab) => {
        if (!tab.hidden) {
          response.push({
            form: tab.models ? formManager.processForm(tab.models, false) : [],
            code: tab.code,
          });
        }
      });

      const urlCall = "/app/studea-manager/apprentice/" + (this.id ? "edit/" + this.id : "add");
      (this.id ? apiConnection.put(urlCall, response) : apiConnection.post(urlCall, response)).then((data) => {
        if (data && !data.hasError) {
          this.cancel();
          notificationManager.showNotification(
            "success",
            this.$tc("global.edit.success", 1, {
              name: this.$t("studea_manager.apprentice.title"),
            }),
          );
        } else if (data.responses && data.responses[0].validationErrors) {
          notificationManager.showNotification("error", this.$t("signed_error"));
          Object.entries(this.tabs).forEach((tab) => {
            const errors = formValidator.processResponses(data.responses[0].validationErrors, tab[1].models);
            if (errors.length) {
              this.invalidTab = this.id ? tab[1] : tab[0];
            }
          });
        }
        this.fetchDesign({ disabledLoading: true });
        this.init();
        this.loading = false;
      });
    },

    validTab() {
      this.invalidTab = null;
    },

    uploaded() {
      this.fileUpload = false;
    },

    uploading() {
      this.fileUpload = true;
    },

    ...mapActions(usePlatformStore, { fetchDesign: "fetchDesign" }),
    ...mapActions(useMainStore, { setAppLoading: "setAppLoading" }),
  },
  components: {
    FormTabsBlockComponent,
  },
};
</script>

<style lang="scss" scoped>
.widget-content {
  padding: 20px;
}

.widget {
  &.-sticky {
    position: sticky;
    bottom: 40px;
    z-index: 1000;

    @include up-to-md {
      bottom: 15px;
    }
  }
}
</style>
